import { event as eventGa } from '@marine/lib';
import { saveAs } from 'file-saver';
import { eventNames } from 'mdc-constants';
import { useCallback } from 'react';
import { useFilesUrlWithToken } from 'services';

// type FileToDownload = {
//   id: string;
//   name: string;
//   extension: string;
// };

export const useDownload = () => {
  const { fileUrlWithToken } = useFilesUrlWithToken();

  const downloadFile = useCallback(
    (fileDownloadUrl?: string) => {
      const fileUrl = fileUrlWithToken(fileDownloadUrl);
      if (fileUrl) {
        const filleUrlWithHttps = fileUrl.replace('http://', 'https://');
        saveAs(filleUrlWithHttps);
        eventGa({
          action: eventNames.fileDownload,
          category: eventNames.fileEventCategory,
          label: eventNames.fileDownloadLabel,
        });
      } else {
        alert('File download failed!');
      }
    },
    [fileUrlWithToken],
  );
  return {
    downloadFile,
  };
};
